import * as React from "react";

import { cn } from "@/lib/utils";

function Card({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card"
      className={cn("rounded-none border border-border bg-card text-card-foreground shadow-none", className)}
      {...props}
    />
  );
}

export { Card };
